// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-logo {
  object-fit: contain;
}
.company-logo--sport-master-logo {
  width: 90px;
}
@media all and (min-width: 1280px) {
  .company-logo--sport-master-logo {
    width: auto;
  }
}
.company-logo--main {
  align-self: flex-start;
  max-height: 25px;
}`, "",{"version":3,"sources":["webpack://./src/components/CompanyLogo/CompanyLogo.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;AADF;AAGE;EACE,WAAA;AADJ;AAGI;EAHF;IAII,WAAA;EAAJ;AACF;AAME;EACE,sBAAA;EACA,gBAAA;AAJJ","sourcesContent":["@import 'src/styles/variables';\n\n.company-logo {\n  object-fit: contain;\n\n  &--sport-master-logo {\n    width: 90px;\n\n    @media all and (min-width: $desktop) {\n      width: auto;\n    }\n  }\n\n  &--chat {\n  }\n\n  &--main {\n    align-self: flex-start;\n    max-height: 25px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
